//import Swal from "sweetalert2";
//import Vue from "vue";
import store from "../../state/store";

import {
  addBankAccount,
  addBankInstallment,
  addBankParameter,
  deleteBankAccount,
  deleteBankInstallment,
  deleteBankParameter,
  getBankAccountList,
  getBankInstallmentList,
  getBankList,
  getBankParametersList,
  getSafeDepositsList,
  updateBankAccount,
  updateBankInstallment,
  updateBankParameter,
  changeBankInstallmentActive,
  getBankParameters,
} from "../../services/modules/bank/bankService";
import {
  showProcessErrorMessage,
  showProcessPromptMessage,
  showProcessSuccessMessage,
} from "../alertHelpers";
import { formatInput } from "@/momentHelper";

export const state = {
  bankList: [],
  bankParameters: [],
  bankAccountList: [],
  bankInstallmentList: [],
  bankParametersList: [],
  bankListHeaders: [],
  bankAccountListHeaders: [],
  bankInstallmentListHeaders: [],
  bankParametersListHeaders: [],
  bankListLoading: false,
  bankAccountListLoading: false,
  bankInstallmentListLoading: false,
  bankParametersListLoading: false,
  bankSafeDepositList: [],
  bankParameterInputs: [],
};

export const mutations = {
  setBankList(state, data) {
    state.bankList = data;
  },
  setBankAccountList(state, data) {
    state.bankAccountList = data;
  },
  setBankParameterInputs(state, data) {
    state.bankParameterInputs = data;
  },
  setBankInstallmentList(state, data) {
    state.bankInstallmentList = data;
  },
  setBankParameters(state, data) {
    state.bankParameters = data;
  },
  setBankParametersList(state, data) {
    state.bankParametersList = data;
  },
  setBankListHeaders(state, data) {
    state.bankListHeaders = data;
  },
  setBankAccountListHeaders(state, data) {
    state.bankAccountListHeaders = data;
  },
  setBankInstallmentHeaders(state, data) {
    state.bankInstallmentListHeaders = data;
  },

  setBankParametersHeaders(state, data) {
    state.bankParametersListHeaders = data;
  },
  setBankListLoading(state, data) {
    state.bankListLoading = data;
  },
  setBankInstallmentListLoading(state, data) {
    state.bankInstallmentListLoading = data;
  },
  setBankAccountListLoading(state, data) {
    state.bankAccountListLoading = data;
  },
  setBankParametersListLoading(state, data) {
    state.bankParametersListLoading = data;
  },
  setSafeDepositList(state, data) {
    state.bankSafeDepositList = data;
  },
};

export const getters = {};

export const actions = {
  async fetchSafeDepositsList(context, { params, body }) {
    let result = await getSafeDepositsList(params, body);
    if (result.data.success) {
      context.commit("setSafeDepositList", result.data.data);
    } else context.commit("setSafeDepositList", result.data.data);
    return result.data.data;
  },

  async fetchBankList(context, { params, body }) {
    context.commit("setBankListLoading", true);
    let result = await getBankList(params, body);

    context.commit("setBankListHeaders", [
      {
        key: "sube",
        label: "Şube",
        sortable: false,
      },
      {
        key: "sube_kodu",
        label: "Şube Kodu",
        sortable: false,
      },
      {
        key: "hesap_no",
        label: "Hesap No",
        sortable: true,
      },
      {
        key: "IBAN",
        label: "IBAN",
        sortable: true,
      },
      {
        key: "banka",
        label: "Banka",
        sortable: true,
      },
      {
        key: "process",
        label: "İşlem",
        sortable: false,
        class: "text-center",
      },
    ]);
    context.commit("setBankListLoading", false);
    if (result.data.success) {
      context.commit("setBankList", result.data.data);
      return result.data.data;
    } else {
      return false;
    }
  },

  async fetchBankAccountList(context, { params, body }) {
    context.commit("setBankAccountListLoading", true);
    let result = await getBankAccountList(params, body);

    context.commit("setBankAccountListHeaders", [
      {
        key: "bank",
        label: "Banka",
        sortable: false,
      },
      {
        key: "branch",
        label: "Şube",
        sortable: false,
      },
      {
        key: "branchCode",
        label: "Şube Kodu",
        sortable: false,
      },
      {
        key: "iban",
        label: "IBAN",
        sortable: false,
      },
      {
        key: "isActive",
        label: "Durum",
        sortable: false,
      },
      {
        key: "process",
        label: "İşlem",
        sortable: false,
        class: "text-center",
      },
    ]);
    context.commit("setBankAccountListLoading", false);
    if (result.data.success) {
      context.commit("setBankAccountList", result.data.data);
      return result.data.data;
    } else {
      return false;
    }
  },
  async fetchSingleBankAccount(context, { params, body }) {
    let result = await getBankAccountList(params, body);

    if (result.data.success) {
      context.commit("setBankAccountList", result.data.data);
      return result.data.data;
    } else {
      return false;
    }
  },
  async bankAccountAdd(context, { params, body }) {
    let result = await addBankAccount(params, body);

    if (result.data.success) {
      showProcessSuccessMessage({
        title: "İşlem Başarılı",
        text: result.data.message,
      });
      context.dispatch("fetchBankAccountList", {
        params: {
          userId: store.state.auth.user.UserId,
        },
        body: {},
      });
    } else
      showProcessErrorMessage({
        title: "İşlem Başarısız",
        text: result.data.message,
      });
  },
  async bankAccountUpdate(context, { params, body }) {
    let result = await updateBankAccount(params, body);

    if (result.data.success) {
      showProcessSuccessMessage({
        title: "İşlem Başarılı",
        text: result.data.message,
      });
      context.dispatch("fetchBankAccountList", {
        params: {
          userId: store.state.auth.user.UserId,
        },
        body: {},
      });
    } else
      showProcessErrorMessage({
        title: "İşlem Başarısız",
        text: result.data.message,
      });
  },

  async bankAccountDelete(context, { params, body }) {
    context;
    showProcessPromptMessage({
      title: "Banka Hesabı Silinecek",
      text: "Yapılan işlem geri alınamayacaktır. İşleme devam etmek istiyor musunuz ?",
    }).then(async function (confirm) {
      if (confirm.isConfirmed) {
        let result = await deleteBankAccount(params, body);
        if (result.data.success) {
          showProcessSuccessMessage({
            title: "İşlem Başarılı",
            text: result.data.message,
          });
          context.dispatch("fetchBankAccountList", {
            params: {
              userId: store.state.auth.user.UserId,
            },
            body: {},
          });
        } else
          showProcessErrorMessage({
            title: "İşlem Başarısız",
            text: result.data.message,
          });

        return result;
      }
    });
  },

  async fetchBankInstallmentList(context, params) {
    context.commit("setBankInstallmentListLoading", true);
    let result = await getBankInstallmentList(params);
    context.commit("setBankInstallmentListLoading", false);
    if (result.data.success) {
      context.commit("setBankInstallmentList", result.data.item);
      return result.data.item;
    } else {
      return [];
    }
  },

  async bankInstallmentAdd(context, body) {
    let result = await addBankInstallment(body);

    if (result.data.success) {
      showProcessSuccessMessage({
        title: "İşlem Başarılı",
        text: result.data.message,
      });
    } else
      showProcessErrorMessage({
        title: "İşlem Başarısız",
        text: result.data.message,
      });
  },

  async bankInstallmentActiveChange(context, body) {
    let result = await changeBankInstallmentActive(body);

    if (result.data.success) {
      showProcessSuccessMessage({
        title: "İşlem Başarılı",
        text: result.data.message,
      });
    } else
      showProcessErrorMessage({
        title: "İşlem Başarısız",
        text: result.data.message,
      });
  },

  async bankInstallmentUpdate(context, body) {
    let result = await updateBankInstallment(body);

    if (result.data.success) {
      showProcessSuccessMessage({
        title: "İşlem Başarılı",
        text: result.data.message,
      });
    } else
      showProcessErrorMessage({
        title: "İşlem Başarısız",
        text: result.data.message,
      });
  },

  async bankInstallmentDelete(context, params) {
    context;
    await showProcessPromptMessage({
      title: "Banka Taksiti Silinecek",
      text: "Yapılan işlem geri alınamayacaktır. İşleme devam etmek istiyor musunuz ?",
    }).then(async function (confirm) {
      if (confirm.isConfirmed) {
        let result = await deleteBankInstallment(params);
        if (result.data.success) {
          showProcessSuccessMessage({
            title: "İşlem Başarılı",
            text: result.data.message,
          });
        } else
          showProcessErrorMessage({
            title: "İşlem Başarısız",
            text: result.data.message,
          });

        return result;
      }
    });
  },

  async fetchBankParameters(context, params) {
    let result = await getBankParameters(params);
    result.data.item.map(
      (item) => (item.parameterInfoKey = formatInput(item.parameterInfoKey))
    );
    result.data.item.map(
      (item) => (item.parameterInfoValue = formatInput(item.parameterInfoValue))
    );
    if (result.data.success) {
      context.commit("setBankParameters", result.data.item);
      return result.data.item;
    } else {
      context.commit("setBankParameters", []);
      return result.data;
    }
  },

  async removeBankParameters(context) {
    context.commit("setBankParameters", []);
  },

  async removeBankInstallments(context) {
    context.commit("setBankInstallmentList", []);
  },

  async fetchBankParametersList(context) {
    context.commit("setBankParametersListLoading", true);
    context.commit("setBankInstallmentHeaders", [
      {
        text: "Taksit Sayısı",
        value: "installment",
        sortable: false,
        width: "150px",
        align: "center",
      },
      {
        text: "Taksit Oranı",
        value: "installmentRate",
        sortable: false,
        width: "150px",
        align: "center",
      },
      {
        text: "Aktiflik",
        value: "isActive",
        sortable: false,
        width: "150px",
        align: "center",
      },
      {
        text: "İşlemler",
        value: "actions",
        sortable: false,
        width: "150px",
        align: "center",
      },
    ]);
    let result = await getBankParametersList();
    result.data.item.map(
      (item) => (item.parameterInfoKey = formatInput(item.parameterInfoKey))
    );
    result.data.item.map(
      (item) => (item.parameterInfoValue = formatInput(item.parameterInfoValue))
    );
    context.commit("setBankParametersListLoading", false);
    if (result.data.success) {
      context.commit("setBankParametersList", result.data.item);
      return result.data.item;
    } else {
      return false;
    }
  },
  async bankParameterAdd(context, { body }) {
    let result = await addBankParameter(body);

    if (result.data.success) {
      showProcessSuccessMessage({
        title: "İşlem Başarılı",
        text: result.data.message,
      });
      context.dispatch("fetchBankParametersList", {});
    } else
      showProcessErrorMessage({
        title: "İşlem Başarısız",
        text: result.data.message,
      });
  },

  async bankParameterUpdate(context, { body }) {
    let result = await updateBankParameter(body);

    if (result.data.success) {
      showProcessSuccessMessage({
        title: "İşlem Başarılı",
        text: result.data.message,
      });
      context.dispatch("fetchBankParametersList", {});
    } else
      showProcessErrorMessage({
        title: "İşlem Başarısız",
        text: result.data.message,
      });
  },

  async bankParameterDelete(context, { params }) {
    context;
    showProcessPromptMessage({
      title: "Banka Parametresi Silinecek",
      text: "Yapılan işlem geri alınamayacaktır. İşleme devam etmek istiyor musunuz ?",
    }).then(async function (confirm) {
      if (confirm.isConfirmed) {
        let result = await deleteBankParameter(params);
        if (result.data.success) {
          showProcessSuccessMessage({
            title: "İşlem Başarılı",
            text: result.data.message,
          });
          context.dispatch("fetchBankParametersList", {});
        } else
          showProcessErrorMessage({
            title: "İşlem Başarısız",
            text: result.data.message,
          });

        return result;
      }
    });
  },
};
